export { default as TabHeaderPerson } from './Person.tab';
export { default as TabHeaderCompany } from './Company.tab';
